<template>
  <div class="bis__modal">
    <div class="bis__modal-desc">
      Enter your email address below and we’ll let you know when it arrives.
    </div>
    <form class="bis__modal-form" v-on:submit="bisSubmit">
      <label>Email Address</label>
      <div class="bis__success"></div>
      <div class="bis__errors"></div>
      <input class="bis__input" name="email" type="email" id="notify_email" required>
      <button class="btn btn--secondary btn--medium" :disabled="loader" id="notify_button">
        {{ loader ? 'SUBMITTING...' : 'SUBMIT'}}
      </button>
    </form> 
    <div class="bis__modal-msg">
      * Information provided here will not be used for any other purposes.
    </div>
  </div>
</template>

<script setup="props">
  import { ref,onBeforeMount, onMounted } from 'vue';

  const props = defineProps({
    productId:{
      type: String,
      required: true,
    },

    variantId:{
      type: String,
      required: true,
    },

    bisDate:{
      type: String,
      default: '',
    }
  })

  const emit = defineEmits(['heading', 'component-updated']) 

  onBeforeMount(() => {
    emit('heading', props.bisDate!='N/A' ? `This item is estimated to be in stock ${props.bisDate}.` : `This item is currently unavailable.`)
  })

  onMounted(() => {
    emit('component-updated');
  })

  const loader = ref(false)

  function bisSubmit(e){
    e.preventDefault();
    loader.value = true;
    const email = e.target.elements.email.value
    const bisFormElem = document.querySelector('.bis__modal-form')
    const bisSuccessElem = document.querySelector('.bis__success')
    const bisErrorsElem = document.querySelector('.bis__errors')
    BIS.create(email, props.variantId, props.productId).then((data)=>{
      let message = ''

      if (data.status === 'OK') {
        message = data.message
        bisSuccessElem.style.display="block"
        bisErrorsElem.style.display="none"
        bisErrorsElem.innerHTML=''
        bisSuccessElem.innerHTML=message
        bisFormElem.querySelector('label').style.display="none"
        bisFormElem.elements.email.style.display='none'
        bisFormElem.elements.notify_button.style.display='none'
      } else {
        for (let item in data.errors) {
          message += data.errors[item].join()
        }

        bisErrorsElem.style.display="block"
        bisSuccessElem.style.display="none"
        bisErrorsElem.innerHTML=message
        bisSuccessElem.innerHTML=''
      }
      loader.value = false;
    })
  }
</script>